import SectionName from '~/constants/new-cars/SectionName';
import type {
  CustomizeRequest,
  SelectedDoors,
  SelectedModelVersion,
  SelectedTrim,
  SelectedTruckBodyStyle,
  SelectedYear
} from '~/contracts/new-cars';
import type { ConfiguratorState } from '../configuratorState';

type SectionSelectionMap = {
  doors: SelectedDoors | null;
  modelVersion: SelectedModelVersion | null;
  options: CustomizeRequest | null;
  trim: SelectedTrim | null;
  truckBodyStyle: SelectedTruckBodyStyle | null;
  year: SelectedYear | null;
};

export default function lookupSelection<S extends SectionName>(
  state: ConfiguratorState,
  section: S
): SectionSelectionMap[S] {
  const map: SectionSelectionMap = {
    doors: state.selectedDoors,
    modelVersion: state.selectedModelVersion,
    options: state.selectedOptions,
    trim: state.selectedTrim,
    truckBodyStyle: state.selectedTruckBodyStyle,
    year: state.selectedYear
  };

  return map[section];
}
